<main class="em-l-container">
  @if (loading) {
    <div>
      <app-loader></app-loader>
    </div>
  }

  @if (!loading) {
    <div>
      <entitlement-breadcrumbs
        [items]="breadcrumbItems"
      ></entitlement-breadcrumbs>
      <div class="em-c-toolbar em-c-toolbar--order">
        <div class="em-c-toolbar__item">
          <div class="em-c-dropdown-check em-js-dropdown-check">
            <div>Service:</div>
          </div>
          <!-- End em-c-dropdown-check -->
        </div>
        <!-- end em-c-toolbar__item -->
      </div>
      <div class="em-c-card-list__item em-l-grid__item">
        <div class="em-c-card service-icon">
          <div class="em-c-card__body">
            <div class="em-c-media-block em-c-media-block--small">
              <span media>
                <unity-icon
                  size="large"
                  [name]="service?.icon!"
                  class="em-u-margin-right-half"
                ></unity-icon>
              </span>
              <!-- end em-c-media-block__media -->
              <span body>
                <h5 class="em-c-media-block__headline">
                  {{ serviceId }}
                </h5>
                <p class="em-c-media-block__desc">{{ service?.name }}</p>
              </span>
              <!-- end em-c-media-block__body -->
            </div>
            <!-- end em-c-media-block -->
          </div>
          <!-- end em-c-card__body -->
        </div>
        <!-- end em-c-card -->
      </div>
      <div class="em-c-toolbar em-c-toolbar--order em-u-margin-bottom-double">
        <div class="em-c-toolbar__item">
          <div class="em-c-dropdown-check em-js-dropdown-check">
            <div>Client list</div>
          </div>
          <!-- End em-c-dropdown-check -->
        </div>
        <!-- end em-c-toolbar__item -->
        <div class="em-c-toolbar__item em-is-aligned-right">
          <div class="em-c-btn-group">
            <div
              class="em-c-field__body top-searchbox em-c-field em-is-readonly"
            >
              <input
                class="em-c-input em-js-input"
                placeholder="Search"
                [(ngModel)]="searchString"
              />
              <svg
                class="em-c-icon em-c-icon--medium em-c-field__icon em-u-clickable"
                (click)="clearSearch()"
              >
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="assets/unity-1.6.0/images/24/em-icons.svg#circle-x"
                ></use>
              </svg>
            </div>
            <button
              unity-button
              (click)="showClient()"
              variant="primary"
              icon="plus"
            >
              Add
            </button>
          </div>
          <!-- end em-c-btn-group -->
        </div>
        <!-- end em-c-toolbar__item -->
      </div>
      <ul class="em-c-accordion">
        @for (client of clients | clientFilter: searchString; track client) {
          <li
            class="em-c-accordion__item em-js-accordion-item {{
              client.id !== expandClientId ? 'em-is-closed' : ''
            }}"
            id="accordion-panel-{{ client.id }}"
          >
            <div class="em-c-accordion__header" (click)="expand(client.id)">
              <a class="em-c-accordion__title em-js-accordion-trigger">
                <div
                  class="em-u-display-flex em-u-width-100"
                  style="justify-content: space-between; align-items: center"
                >
                  <div>
                    <svg
                      class="em-c-icon em-c-icon--small em-c-accordion__icon"
                    >
                      <use
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="assets/unity-1.6.0/images/em-icons.svg#caret-down"
                      ></use>
                    </svg>
                    <span class="em-c-accordion__title-text">{{
                      client.name
                    }}</span>
                  </div>
                  <div>
                    <button
                      unity-button
                      [routerLink]="[
                        '/entitlement-service-client',
                        client.id,
                        serviceId,
                      ]"
                      size="small"
                      variant="tertiary"
                      icon="settings"
                      [iconOnly]="true"
                    ></button>
                  </div>
                </div>
              </a>
            </div>
            <!-- end em-c-accordion__header -->
            <div class="em-c-accordion__body">
              <div class="em-c-table-object__body-inner">
                <table class="em-c-table">
                  <!-- Table Header -->
                  <thead class="em-c-table__header">
                    <tr class="em-c-table__header-row">
                      @for (key of entitlementKey; track key) {
                        <th scope="col" class="em-c-table__header-cell">
                          {{ key }}
                        </th>
                        <th scope="col" class="em-c-table__header-cell">
                          Description
                        </th>
                      }
                    </tr>
                  </thead>
                  <!-- Table Body -->
                  <tbody class="em-c-table__body">
                    @for (
                      data of entitlementServiceKeys[client.id] | keyvalue;
                      track data
                    ) {
                      <tr class="em-c-table__row">
                        @for (key of entitlementKey; track key) {
                          <td scope="col" class="em-c-table__cell em-js-cell">
                            <span class="entitlement-key">
                              {{
                                entitlementKey[0] === key
                                  ? data.key
                                  : getValues(data.value, key)
                              }}
                            </span>
                          </td>
                          <td scope="col" class="em-c-table__cell em-js-cell">
                            {{ getDescription(data.value, key) }}
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <!-- end div table -->
            </div>
            <!-- end em-c-accordion__body -->
          </li>
        }
        <!-- end em-c-accordion__item -->
      </ul>
      <!-- end em-c-accordion -->
    </div>
  }

  <!-- Modal to add client -->
  @if (showModalBox) {
    <div class="em-c-modal em-js-modal" id="modal">
      <div class="em-c-modal__window em-js-modal-window">
        <div class="em-c-modal__header">
          <h3 class="em-c-modal__title">Add Client</h3>
          <button
            class="em-c-btn em-c-btn--bare em-c-modal__close-btn em-js-modal-close-trigger"
          >
            <span class="em-c-btn__text" (click)="showModalBox = false"
              >Close</span
            >
          </button>
          <!-- end em-c-btn -->
        </div>
        <!-- end em-c-modal__header -->
        <div
          class="em-c-modal__body em-c-text-passage em-c-text-passage--small"
        >
          <client-input [(selectedValue)]="client" [serviceId]="serviceId">
          </client-input>
          <div>{{ clientName }}</div>
          <div class="em-c-btn-group em-c-modal--alert em-js-modal-only">
            <button
              class="em-c-btn em-c-btn--primary em-js-modal-confirm-trigger"
              (click)="addClient()"
              [disabled]="isOkButtonDisabled"
            >
              <span class="em-c-btn__text">OK</span>
            </button>
            <!-- end em-c-btn -->
            <button
              class="em-c-btn em-c-btn--secondary em-js-modal-cancel-trigger"
              (click)="showModalBox = false"
            >
              <span class="em-c-btn__text">Cancel</span>
            </button>
            <!-- end em-c-btn -->
          </div>
          <!-- end em-c-btn-group -->
        </div>
        <!-- end em-c-modal__footer -->
      </div>
      <!-- end em-c-modal__window -->
    </div>
  }
  <!-- end em-c-modal -->
</main>
